/**
 * Website view of the shared product metadata.
 *
 * The product's copy, identifiers and claims live in
 * `@transport/product-metadata`, which the Microsoft Store listing and the apps
 * read from too. This module adapts them to the shapes the pages already use
 * and adds the things that are the website's alone — its navigation and the
 * per-deploy origin.
 *
 * Change a feature list, a description or a URL in the package, never here.
 */
import {
  ORIGIN,
  product,
  tagline,
  microsoftStore as storeIdentity,
} from '@transport/product-metadata';

export {
  onboardingMigration,
  capabilityMap,
  clientComparison,
  driverProduct,
  faqs,
  faqTopics,
  featureGroups,
  hindiDemoVideo,
  homepageHero,
  homepageWorkflow,
  installWarnings,
  integrationGroups,
  platformMatrix,
  productShots,
  websiteScreenshotDescription,
  businessDetails,
  indianStateNames,
  urls,
  webApp,
  categories,
  pricing,
  pricingNotes,
  pricingPromises,
  plans,
  completeEdition,
  brokerExamples,
  fleetExamples,
  perTruckPerDay,
  describeQuote,
  formatInr,
  quoteForTrucks,
  planPriceLines,
  planTrucksLabel,
  operatingSystems,
  searchPages,
  type PlanQuote,
  type SearchPage,
} from '@transport/product-metadata';

export const site = {
  name: product.name,
  // The only value that differs per deploy: preview builds render their own origin.
  origin: import.meta.env.VITE_SITE_URL || ORIGIN,
  description: tagline,
  demoEmail: product.contactEmail,
  publisher: product.publisher,
};

// The Microsoft Store listing is the preferred way to install on Windows: it
// handles installation and updates, and the package is signed by the Store.
// Direct installers stay available for machines that cannot reach the Store.
export const microsoftStore = storeIdentity;

// Website-only: which of the pages appear in the header.
export const navigation = [
  { href: '/features', label: 'Features' },
  { href: '/desktop', label: 'Desktop' },
  { href: '/web', label: 'Web app' },
  { href: '/mobile', label: 'Mobile' },
  { href: '/integrations', label: 'Integrations' },
  { href: '/pricing', label: 'Pricing' },
  { href: '/downloads/desktop', label: 'Downloads' },
  { href: '/support', label: 'Support' },
];
